<template>
  <InteractionStep
                   :disabled-next="!isReady"
                   :pending-next="pendingSave"
                   @next="onSave">

    <template v-slot:content>
      <div class="step-text">
        <img src="../../../assets/img/svg/employment-type/4.svg"
             :alt="$tInteraction('Note')"
             class="step-text__img">
        <h3 class="step-text__title">{{ $tInteraction('Note') }}</h3>
        <div class="step-text__text text">
          <p>{{ $tInteraction('After the job invitation for the candidate is ready, be sure to confirm it by clicking the corresponding button below') }}</p>
        </div>

        <div class="step-text__options step-options">
          <div class="step-options__inner">
            <label class="step-options__item">
              <input type="checkbox"
                     name="type-option"
                     v-model="isReady"
                     hidden>
              <span class="step-options__item-mark">
                <BaseSvg name="ico-check"/>
              </span>
              <span class="step-options__item-inner">
                <span>{{ $tInteraction('Consecration is ready') }}</span>
              </span>
            </label>
          </div>
        </div>
      </div>
      <BaseAlert :value="error" class="step-information__error  _error"/>
    </template>
  </InteractionStep>
</template>

<script>
  import InteractionStep from '../InteractionStep'
  import {http} from "../../../axios"
  import interactionStepMixin from "@/mixins/interactionStepMixin"

  export default {
    name: 'InteractionStepPassport2',
    mixins: [interactionStepMixin],
    data() {
      return {
        pendingSave: false,
        error: null,
        isReady: false
      }
    },
    components: {
      InteractionStep
    },
    methods: {
      onSave() {
        this.error = null
        this.pendingSave = true

        http.post(`/api/new-interaction/${this.$route.params.id}/5`).then(async () => {
          await this.$store.dispatch('interaction/loadInteraction')
        }).catch(e => {
          this.handleInteractionError(e)
        }).finally(() => {
          this.pendingSave = false
        })
      }
    }
  }
</script>

<style>

</style>
